import { Routes } from '@angular/router';
import { RentalClassOverviewService } from '@app/admin/rental-classes/overview/services/rental-class-overview.service';
import { AddService } from '@app/admin/rental-classes/add/services/add.service';
import { DetailService } from '@app/admin/rental-classes/detail/services/detail.service';

export const rentalClassesRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/rental-classes/overview/overview.component').then(component => component.OverviewComponent),
    providers: [RentalClassOverviewService,],
  },
  {
    path: 'add',
    loadComponent: () => import('@app/admin/rental-classes/add/add.component').then(component => component.AddComponent),
    providers: [AddService],
  },
  {
    path: ':id',
    loadComponent: () => import('@app/admin/rental-classes/detail/detail.component').then(component => component.DetailComponent),
    providers: [DetailService],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
